module.exports = __webpack_public_path__ + "assets-customer/images/security-seals.png?149706ff";